// extracted by mini-css-extract-plugin
module.exports = {"card":"CameraList_card__2bsX4"};